const LAST_WORKSPACE_SCOPE_KEY = 'dn_last_workspace_scope';

export const workspaceScopeHeaders = (workspace) => (workspace.parentId
  ? { 'X-Workspace-Id': workspace.parentId, 'X-Workspace-View-Id': workspace.id }
  : { 'X-Workspace-Id': workspace.id, 'X-Workspace-View-Id': null });

export const isSameWorkspaceScope = (headers, otherHeaders) => (
  headers['X-Workspace-Id'] === otherHeaders['X-Workspace-Id']
  && headers['X-Workspace-View-Id'] === otherHeaders['X-Workspace-View-Id']
);

export const workspaceScopeOwner = (userSession) => (
  userSession?.email && userSession?.clientId ? `${userSession.email}|${userSession.clientId}` : null
);

export const readLastWorkspaceScope = (owner, index) => {
  if (!owner) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(LAST_WORKSPACE_SCOPE_KEY));
    return saved?.owner === owner && saved?.index === index ? saved.headers : null;
  } catch {
    return null;
  }
};

export const saveLastWorkspaceScope = (owner, index, headers) => {
  if (!owner) return false;
  try {
    localStorage.setItem(LAST_WORKSPACE_SCOPE_KEY, JSON.stringify({ owner, index, headers }));
    return true;
  } catch {
    return false;
  }
};
